/* eslint-disable */

import axios from "axios";
import { AppAPIKey, getDomain } from "./domain";
import { login_auth2_url, refresh_url } from "./constants";
import { getParameterByName, setDebug } from "./utils";

export const EXTRA_TOKEN = "extraToken";
export const REFRESH_TOKEN = "refreshToken";
export const ID_TOKEN = "idToken";
export const TOKEN_TYPE = "tokenType";
export const EXPIRE = "expire";
export const USERNAME = "username";
export const USER_INFO = "userInfo";

let id = null;

export const removeTokens = () => {
  localStorage.removeItem("agent_id");
  localStorage.removeItem(USERNAME);
  localStorage.removeItem(EXTRA_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(ID_TOKEN);
  localStorage.removeItem(TOKEN_TYPE);
  localStorage.removeItem(EXPIRE);
};

export const handleLogoutRedirect = (redirectUrl = "") => {
  let domain = getDomain();
  const lgoStr = "/lgo";
  const lgoDomainIndex = domain.indexOf(lgoStr);
  if (lgoDomainIndex !== -1) {
    // Remove "/lgo/" from the domain
    domain =
      domain.slice(0, lgoDomainIndex) +
      domain.slice(lgoDomainIndex + lgoStr.length);
  }

  let redirectTo = redirectUrl || `${domain}/webagent/`;

  // Check if "/lgo/" exists in the redirect URL
  const lgoRedirectIndex = redirectTo.indexOf(lgoStr);
  if (lgoRedirectIndex !== -1) {
    // Remove "/lgo/" from the redirect
    redirectTo =
      redirectTo.slice(0, lgoRedirectIndex) +
      redirectTo.slice(lgoRedirectIndex + lgoStr.length);
  }

  // Remove tokens
  removeTokens();
  window.location = `${domain}/login/?redirect=${redirectTo}`;
};

export function logoutRedirect(redirectUrl) {
  console.log('Viene con redirect to', redirectUrl);
  const domain = 'https://go.invoxcontact.io/auth?';
  const redirectTo = redirectUrl || `${domain}/webagent/`;
  console.log('Logout, redirect to', redirectTo);
  removeTokens();
  window.location = `${domain}redirect=${redirectTo}`;
  
}

export const handleWrongPasswordLogout = () => {
  const domain = getDomain();

  removeTokens();
  window.location = `${domain}/login/?redirect=${domain}/webagent/&loginerror=1`;
};

const onAuthError = (error) => {
  if (
    error &&
    error.data &&
    error.data.result === "false" &&
    error.data.error === "invalid code"
  ) {
    return handleWrongPasswordLogout();
  }

  handleLogoutRedirect();
};

const refreshTokens = () => {
  const body = { RefreshToken: localStorage.getItem(REFRESH_TOKEN) };
  const headers = {
    "Content-Type": "application/json",
    "x-api-key": AppAPIKey,
  };

  axios
    .put(refresh_url, body, { headers })
    .then((response) => {
      setTokens(response.data);
    })
    .catch((error) => {
      console.error("Refresh Token - Request Failed");
      if (error && error.status && error.status.toString() === "401") {
        handleLogoutRedirect();
      }
    });
};

const setTimeoutForRefreshToken = () => {
  const expire = localStorage.getItem(EXPIRE);
  const time = Number(expire) * 1000 - Date.now();

  if (!(expire && Number(expire) * 1000 > Date.now())) {
    return;
  }

  clearTimeout(id);

  id = setTimeout(() => {
    refreshTokens();
  }, time);
};

const setTokens = (response) => {
  if (response.hasOwnProperty("RefreshToken")) {
    localStorage.setItem(REFRESH_TOKEN, response.RefreshToken);
    localStorage.setItem(EXTRA_TOKEN, response.ExtraToken);
    localStorage.setItem(ID_TOKEN, response.IdToken);
    localStorage.setItem(TOKEN_TYPE, response.TokenType);
    localStorage.setItem(EXPIRE, response.Expire);

    setTimeoutForRefreshToken();
  }
};

const onAuthSuccess = (response, postLogin) => {
  const state = { additionalInformation: "Updated the URL with JS" };
  const title = document.title;
  const url = window.location.href.split("?")[0];
  window.history.replaceState(state, title, url);

  setTokens(response);
  postLogin(true);
};

export const checkLogin = (postLogin) => {
  const debug = getParameterByName("debug");
  const token = getParameterByName("tk");
  const version = getParameterByName("vrs");
  const WpVersion = getParameterByName("wpvrs");

  if (version) {
    localStorage.setItem("invoxVersion", version);
    localStorage.setItem("goVersionPluginWP", WpVersion);
  }
  
  const expire = localStorage.getItem(EXPIRE);
  const isTokenExpired = !(expire && Number(expire) * 1000 > Date.now());

  getDomain();
  setDebug(debug === "true");

  if (token) {
    const body = { code: token };
    const headers = {
      "Content-Type": "application/json",
      "x-api-key": AppAPIKey,
    };

    axios
      .put(login_auth2_url, body, { headers })
      .then((response) => {
        if (response && response.data && response.data.result === "true") {
          onAuthSuccess(response.data, postLogin);
        } else {
          onAuthError(response);
        }
      })
      .catch((error) => {
        onAuthError(error);
        if (error && error.status && error.status.toString() === "401") {
          handleLogoutRedirect();
        }
      });
  } else if (isTokenExpired) {
    handleLogoutRedirect(
      window.location.href.includes("localhost") ? window.location.href : ""
    );
  } else {
    setTimeoutForRefreshToken();
    postLogin();
  }
};



// WEBPACK FOOTER //
// ./src/utils/authutils.js